import type { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import { Link, type LinkProps } from "react-router";
import { twMerge } from "tailwind-merge";

import type { Require } from "@/types/Require";

export function Button({
  children,
  attention,
  className,
  ...props
}: { attention?: "danger" | "submit" } & Require<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  "type"
>) {
  return (
    // oxlint-disable-next-line button-has-type
    <button
      className={twMerge(
        "relative isolate inline-flex h-[2.75rem] items-center justify-center rounded-full border border-divider bg-white px-4 font-interest not-disabled:cursor-pointer disabled:cursor-default",
        attention === "submit" &&
          "bg-grass/40 hover:not-disabled:bg-grass/50 disabled:bg-grass/20 disabled:grayscale-25",
        attention === "danger" &&
          "bg-danger/30 hover:not-disabled:bg-danger/40 disabled:bg-danger/20 disabled:grayscale-25",
        attention === undefined &&
          "hover:not-disabled:bg-[hsl(from_white_h_s_98)] disabled:bg-[hsl(from_white_h_s_95)]",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}

export function ButtonLink({
  children,
  attention,
  className,
  ...props
}: { attention?: "danger" | "submit" } & LinkProps) {
  return (
    <Link
      className={twMerge(
        "relative isolate inline-flex h-[2.75rem] items-center justify-center rounded-full border border-divider bg-white px-4 font-interest not-disabled:cursor-pointer disabled:cursor-default",
        attention === "submit" && "bg-grass/40 hover:not-disabled:bg-grass/50 disabled:grayscale-25",
        attention === "danger" && "bg-danger/40 hover:not-disabled:bg-danger/50 disabled:grayscale-25",
        attention === undefined &&
          "hover:not-disabled:bg-[hsl(from_white_h_s_98)] disabled:bg-[hsl(from_white_h_s_95)]",
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  );
}
